import { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
  Alert
} from '@mui/material'
import { useApp } from '../../hooks/useApp'
import { REQUEST_TYPES } from '../../constants'

const ContactForm = ({ open, onClose, product }) => {
  const { dispatch } = useApp()
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  })
  const [errors, setErrors] = useState({})
  const [submitted, setSubmitted] = useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
    // Limpiar error cuando el usuario empieza a escribir
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }))
    }
  }

  const validateForm = () => {
    const newErrors = {}
    
    if (!formData.name.trim()) {
      newErrors.name = 'El nombre es requerido'
    }
    
    if (!formData.email.trim()) {
      newErrors.email = 'El email es requerido'
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email inválido'
    }
    
    if (!formData.phone.trim()) {
      newErrors.phone = 'El teléfono es requerido'
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    
    if (!validateForm()) return

    const request = {
      id: Date.now(),
      fecha: new Date().toISOString(),
      producto: product.name,
      tipo: REQUEST_TYPES.CONTACT,
      cliente: {
        nombre: formData.name,
        email: formData.email,
        telefono: formData.phone
      },
      mensaje: formData.message,
      estado: 'pendiente'
    }

    dispatch({ type: 'ADD_REQUEST', payload: request })
    setSubmitted(true)
    
    // Cerrar después de 2 segundos
    setTimeout(() => {
      onClose()
      setSubmitted(false)
      setFormData({ name: '', email: '', phone: '', message: '' })
    }, 2000)
  }

  const handleClose = () => {
    onClose()
    setErrors({})
    setSubmitted(false)
  }

  if (submitted) {
    return (
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogContent sx={{ textAlign: 'center', py: 4 }}>
          <Alert severity="success" sx={{ mb: 2 }}>
            ¡Solicitud enviada exitosamente!
          </Alert>
          <Typography variant="body1">
            Nos contactaremos contigo pronto sobre: <strong>{product?.name}</strong>
          </Typography>
        </DialogContent>
      </Dialog>
    )
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Solicitar Contacto
        <Typography variant="body2" color="text.secondary">
          Producto: {product?.name}
        </Typography>
      </DialogTitle>
      
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
            <TextField
              name="name"
              label="Nombre completo"
              value={formData.name}
              onChange={handleChange}
              error={!!errors.name}
              helperText={errors.name}
              fullWidth
              required
            />
            
            <TextField
              name="email"
              label="Email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              error={!!errors.email}
              helperText={errors.email}
              fullWidth
              required
            />
            
            <TextField
              name="phone"
              label="Teléfono"
              value={formData.phone}
              onChange={handleChange}
              error={!!errors.phone}
              helperText={errors.phone}
              fullWidth
              required
            />
            
            <TextField
              name="message"
              label="Mensaje (opcional)"
              multiline
              rows={3}
              value={formData.message}
              onChange={handleChange}
              fullWidth
              placeholder="Cuéntanos más sobre tu consulta..."
            />
          </Box>
        </DialogContent>
        
        <DialogActions sx={{ p: 3 }}>
          <Button onClick={handleClose}>
            Cancelar
          </Button>
          <Button type="submit" variant="contained">
            Enviar Solicitud
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default ContactForm